"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactComponents = require("@cimpress/react-components");
var _reactIntl = require("react-intl");
var _IconInformationCircle = _interopRequireDefault(require("@cimpress-technology/react-streamline-icons/lib/IconInformationCircle"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
var _i18n = require("../utils/i18n");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var priceAdjustmentEndpoint = 'https://price-adjustments.commerce.cimpress.io/v1/priceAdjustments';
var Spinner = _reactComponents.shapes.Spinner;
var spinner = /*#__PURE__*/_react["default"].createElement(Spinner, {
  size: "small",
  className: 'no-padding',
  style: {
    padding: '0'
  }
});
var alertBoxTitle = {
  danger: 'adjustment:request_error',
  success: 'adjustment:request_submitted'
};
var PriceAdjustment = /*#__PURE__*/function (_React$Component) {
  _inherits(PriceAdjustment, _React$Component);
  var _super = _createSuper(PriceAdjustment);
  function PriceAdjustment(props) {
    var _this;
    _classCallCheck(this, PriceAdjustment);
    _this = _super.call(this, props);
    _this.onInputChange = function (event) {
      if (_this.validateNewPrice(event.target.value)) {
        _this.setState({
          newPrice: event.target.value,
          isPriceValid: true
        });
      } else {
        _this.setState({
          newPrice: event.target.value,
          isPriceValid: false
        });
      }
    };
    _this.onChange = function (e, value) {
      _this.setState({
        reason: value
      });
    };
    _this.onNoteChange = function (event) {
      _this.setState({
        notes: event.target.value
      });
    };
    _this.validateNewPrice = function (value) {
      return !(value.trim() === '' || value <= 0 || isNaN(value));
    };
    _this.priceAdjustmentRequest = function (requestBody) {
      var headers = {
        authorization: "Bearer ".concat(_this.props.accessToken)
      };
      _axios["default"].post(priceAdjustmentEndpoint, _objectSpread({}, requestBody), {
        headers: headers
      }).then(function (response) {
        if (_this.props.onSetPrice && typeof _this.props.onSetPrice === 'function') {
          _this.props.onSetPrice({
            data: response.data,
            status: response.status,
            statusText: response.statusText
          });
        }
        _this.setState({
          callingApi: false,
          disableSetPriceButton: true,
          showAlert: true,
          alertType: 'success',
          alertMessage: ''
        });
      })["catch"](function (error) {
        if (error && error.response) {
          if (_this.props.onSetPrice && typeof _this.props.onSetPrice === 'function') {
            _this.props.onSetPrice({
              data: error.response.data,
              status: error.response.status,
              statusText: error.response.statusText
            });
          }
          _this.setState({
            callingApi: false,
            showAlert: true,
            alertType: 'danger',
            alertMessage: "".concat(error.response.status, " - ").concat(error.response.statusText)
          });
        } else {
          _this.setState({
            callingApi: false,
            showAlert: true,
            alertType: 'danger',
            alertMessage: ""
          });
        }
      });
    };
    _this.onSetPrice = function () {
      var _this$state = _this.state,
        reason = _this$state.reason,
        notes = _this$state.notes,
        newPrice = _this$state.newPrice;
      var _this$props = _this.props,
        itemId = _this$props.itemId,
        itemUrl = _this$props.itemUrl;
      var requestBody = {
        reason: reason,
        notes: notes,
        status: 'resolved',
        items: [{
          newPrice: newPrice,
          _links: {
            item: {
              href: itemUrl,
              name: itemId
            }
          }
        }]
      };
      _this.setState({
        callingApi: true,
        showAlert: false,
        alertMessage: '',
        alertType: ''
      }, function () {
        return _this.priceAdjustmentRequest(requestBody);
      });
    };
    _this.state = {
      newPrice: '',
      reason: 'Delivery Speed Change',
      notes: '',
      isPriceValid: false,
      callingApi: false,
      disableSetPriceButton: false,
      showAlert: false,
      alertType: '',
      alertMessage: ''
    };
    return _this;
  }
  _createClass(PriceAdjustment, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.show !== this.props.show) {
        this.setState({
          newPrice: '',
          reason: 'Delivery Speed Change',
          notes: '',
          isPriceValid: false,
          callingApi: false,
          disableSetPriceButton: false,
          showAlert: false,
          alertType: '',
          alertMessage: ''
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        show = _this$props2.show,
        price = _this$props2.price;
      var _this$state2 = this.state,
        isPriceValid = _this$state2.isPriceValid,
        disableSetPriceButton = _this$state2.disableSetPriceButton,
        notes = _this$state2.notes,
        reason = _this$state2.reason,
        newPrice = _this$state2.newPrice,
        callingApi = _this$state2.callingApi,
        showAlert = _this$state2.showAlert,
        alertMessage = _this$state2.alertMessage,
        alertType = _this$state2.alertType;
      var error = /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: '#bc2213'
        }
      }, " ", !isPriceValid && newPrice.trim() !== '' ? (0, _i18n.tt)(this.props, 'adjustment:invalid_price') : '');
      return /*#__PURE__*/_react["default"].createElement(_reactComponents.Modal, {
        show: show,
        title: (0, _i18n.tt)(this.props, 'adjustment:adjust_price'),
        closeButton: true,
        style: {
          width: '450px'
        },
        onRequestHide: this.props.onClose,
        footer: /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-default",
          onClick: this.props.onClose
        }, (0, _i18n.tt)(this.props, 'adjustment:close')), /*#__PURE__*/_react["default"].createElement("button", {
          className: "btn btn-primary",
          disabled: !isPriceValid || callingApi || disableSetPriceButton,
          onClick: function onClick() {
            return _this2.onSetPrice();
          }
        }, (0, _i18n.tt)(this.props, 'adjustment:set_price')))
      }, /*#__PURE__*/_react["default"].createElement("div", null, showAlert ? /*#__PURE__*/_react["default"].createElement(_reactComponents.Alert, {
        type: alertType,
        title: (0, _i18n.tt)(this.props, alertBoxTitle[alertType]),
        message: alertMessage,
        dismissible: true
      }) : null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '20px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontWeight: 600,
          fontSize: '14px',
          marginBottom: '4px'
        }
      }, (0, _i18n.tt)(this.props, 'adjustment:current_price')), /*#__PURE__*/_react["default"].createElement("div", null, price && price.currency && price.amount && !isNaN(Number(price.amount)) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedNumber, {
        currency: price.currency,
        style: "currency",
        value: price.amount
      }) : (0, _i18n.tt)(this.props, 'adjustment:n_a'))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '20px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontWeight: 600,
          fontSize: '14px',
          marginBottom: '4px'
        }
      }, (0, _i18n.tt)(this.props, 'adjustment:new_price')), /*#__PURE__*/_react["default"].createElement(_reactComponents.TextField, {
        inputStyle: {
          height: '24px'
        },
        name: "normal",
        style: {
          width: '60%'
        },
        value: newPrice,
        onChange: this.onInputChange,
        helpText: error,
        autoComplete: "off"
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '15px'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontWeight: 600,
          fontSize: '14px',
          marginBottom: '4px'
        }
      }, (0, _i18n.tt)(this.props, 'adjustment:reason_for_price_change')), /*#__PURE__*/_react["default"].createElement(_reactComponents.RadioGroup, {
        onChange: this.onChange,
        defaultSelected: "Delivery Speed Change",
        name: "reason"
      }, /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
        label: (0, _i18n.tt)(this.props, 'adjustment:reason_delivery_speed_change'),
        value: "Delivery Speed Change"
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
        label: (0, _i18n.tt)(this.props, 'adjustment:reason_artwork_change'),
        value: "Artwork Change"
      }), /*#__PURE__*/_react["default"].createElement(_reactComponents.Radio, {
        label: (0, _i18n.tt)(this.props, 'adjustment:reason_other'),
        value: "Other"
      })), reason === 'Other' ? /*#__PURE__*/_react["default"].createElement(_reactComponents.TextField, {
        name: "textarea",
        label: (0, _i18n.tt)(this.props, 'adjustment:reason'),
        value: notes,
        onChange: this.onNoteChange,
        type: "textarea",
        required: true
      }) : null), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_IconInformationCircle["default"], {
        color: "#6a7884",
        weight: "fill",
        style: {
          marginRight: '4px',
          marginBottom: '-1px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: '#6a7884',
          fontSize: '14px',
          marginTop: '20px'
        }
      }, (0, _i18n.tt)(this.props, 'adjustment:info_processing_times'))), callingApi ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'grid',
          placeItems: 'center',
          paddingTop: '10px'
        }
      }, spinner) : null));
    }
  }]);
  return PriceAdjustment;
}(_react["default"].Component);
exports["default"] = PriceAdjustment;
PriceAdjustment.propTypes = {
  accessToken: _propTypes["default"].string.isRequired,
  show: _propTypes["default"].bool.isRequired,
  price: _propTypes["default"].shape({
    amount: _propTypes["default"].string,
    currency: _propTypes["default"].string
  }).isRequired,
  itemId: _propTypes["default"].string.isRequired,
  itemUrl: _propTypes["default"].string.isRequired,
  onClose: _propTypes["default"].func.isRequired,
  onSetPrice: _propTypes["default"].func,
  locale: _propTypes["default"].string
};
PriceAdjustment.defaultProps = {
  locale: 'en'
};